var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorMessage',{attrs:{"title":_vm.trans('spa.error.content-not-available'),"message":_vm.trans('spa.error.use-desktop-not-mobile')}},[_c('SmileyDesktopImage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }